<template>
  <div>
    <div class="row m-hide-lg repeater-row-lg">
      <div class="col-lg">
        <label>{{ $t('products.workflows.assignToWorkflow') }}</label>
      </div>
      <div class="col repeater-last-col-single"></div>
    </div>
    <div v-if="renderedComponent">
      <workflow-row
              :key="index"
              :usedWorkflows="usedWorkflows"
              :workflow="workflow"
              :workflowIndex="index"
              :workflows="product.workflows"
              @addWorkflowRow="addWorkflowRow()"
              @input="workflowSelected($event,index)"
              @workflowRemoved="removeWorkflowRow($event)"
              v-for="(workflow, index) in product.workflows"
      />
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import WorkflowRow from './WorkflowRow'
  import {renderComponent} from '../../mixins/renderComponent'

  //@vuese
  // @group Products
  export default {
    name: 'ProductWorkflows',
    components: {WorkflowRow},
    props: ['product'],
    mixins: [renderComponent],
    computed: {
      ...mapGetters('workflows', [
        'getWorkflows'
      ]),
      //@vueuse
      usedWorkflows() {
        let usedWorkflowArray = [];
        this.product.workflows.forEach((workflow) => {
          if(workflow) {
            usedWorkflowArray.push(workflow)
          }
        });

        return _.filter(this.getWorkflows, function (loc) {
          return !_.includes(usedWorkflowArray, loc.id)
        });
      }
    },
    methods: {
      //@vueuse
      workflowSelected(event, index) {
        if(_.findIndex(this.product.workflows, event) === -1) {
          this.product.workflows.splice(index, 1, event)
        }
      },
      //@vueuse
      addWorkflowRow() {
        this.product.workflows.push('');
      },
      //@vueuse
      removeWorkflowRow(index) {
        this.product.workflows.splice(index, 1);
        this.renderComponent();
      }
    },
    created() {
      let workflows = this.product.workflows;
      if(workflows.length === 0) {
        this.addWorkflowRow();
        this.$emit('addedRow', true)
      }
    }
  }
</script>